








import { Component, Vue, Prop, Watch } from "vue-property-decorator";

@Component({
  name: "uc-menu"
})
export default class UcMenuComponent extends Vue{
  
};



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./scripts/views/layouts/menu/uc-menu.vue